import React, { useState } from "react";
import { Box, Button, Typography, Paper, Select, MenuItem, InputLabel, FormControl, CircularProgress } from "@material-ui/core";
import { functions } from "../../firebase";

const FILE_TYPES = [
  { key: "UPC.txt", label: "UPC.txt (UPC codes)" },
  { key: "apple_ids.csv", label: "apple_ids.csv" },
  { key: "update_payments.csv", label: "update_payments.csv" },
  { key: "remove_payments.csv", label: "remove_payments.csv" },
  { key: "block_accounts.csv", label: "block_accounts.csv" },
  { key: "artists.csv", label: "artists.csv" },
  { key: "multas.txt", label: "multas.txt" },
  { key: "first_periods.csv", label: "first_periods.csv" },
];

function detectFileType(filename) {
  const match = FILE_TYPES.find((t) => filename.endsWith(t.key));
  return match ? match.key : "";
}

async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const AdminDrops2 = () => {
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const f = e.target.files[0];
    setFile(f);
    setImportResult(null);
    setError("");
    setPreview(null);
    if (f) {
      const detected = detectFileType(f.name);
      setFileType(detected);
      setLoading(true);
      try {
        const base64 = await fileToBase64(f);
        const drops2ProcessFile = functions.httpsCallable("drops2ProcessFile");
        const res = await drops2ProcessFile({ fileContent: base64, fileType: detected, import: false });
        setPreview({
          count: res.data.count,
          lines: res.data.preview,
        });
      } catch (err) {
        setError("Error al procesar el archivo: " + (err.message || err));
      }
      setLoading(false);
    } else {
      setPreview(null);
      setFileType("");
    }
  };

  const handleTypeChange = (e) => {
    setFileType(e.target.value);
  };

  const handleImport = async () => {
    if (!file || !fileType) return;
    setLoading(true);
    setImportResult(null);
    setError("");
    try {
      const base64 = await fileToBase64(file);
      const drops2ProcessFile = functions.httpsCallable("drops2ProcessFile");
      const res = await drops2ProcessFile({ fileContent: base64, fileType, import: true });
      setImportResult({
        success: true,
        message: `Importados: ${res.data.imported} / ${res.data.count}` + (res.data.errors && res.data.errors.length ? `\nErrores: ${res.data.errors.join(", ")}` : ""),
        skipped: res.data.skipped || [],
      });
    } catch (err) {
      setImportResult({ success: false, message: "Error al importar: " + (err.message || err) });
    }
    setLoading(false);
  };

  return (
    <Box maxWidth={600} mx="auto" mt={14}>
      <Paper style={{ padding: 32 }}>
        <Typography variant="h5" gutterBottom>
          Drops 2
        </Typography>
        <Box mt={2} mb={2}>
          <input
            type="file"
            accept=".txt,.csv"
            onChange={handleFileChange}
            style={{ marginBottom: 16 }}
          />
        </Box>
        <FormControl fullWidth variant="outlined" style={{ marginBottom: 16 }}>
          <InputLabel id="file-type-label">Tipo de archivo</InputLabel>
          <Select
            labelId="file-type-label"
            value={fileType}
            onChange={handleTypeChange}
            label="Tipo de archivo"
          >
            <MenuItem value=""><em>Detectar automáticamente</em></MenuItem>
            {FILE_TYPES.map((t) => (
              <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {loading && <Box mb={2}><CircularProgress /></Box>}
        {preview && !loading && (
          <Box mb={2}>
            <Typography variant="subtitle1">
              Líneas detectadas: {preview.count}
            </Typography>
            <Typography variant="subtitle2">Preview:</Typography>
            <Paper variant="outlined" style={{ maxHeight: 200, overflow: "auto", padding: 8 }}>
              <pre style={{ margin: 0 }}>{preview.lines.join("\n")}</pre>
            </Paper>
          </Box>
        )}
        {error && (
          <Typography color="error" gutterBottom>{error}</Typography>
        )}
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            disabled={!file || !fileType || loading}
            onClick={handleImport}
            fullWidth
          >
            {loading ? <CircularProgress size={24} /> : "Importar"}
          </Button>
        </Box>
        {importResult && (
          <Box mt={2}>
            <Typography color={importResult.success ? "primary" : "error"}>
              {importResult.message}
            </Typography>
            {importResult.skipped && importResult.skipped.length > 0 && (
              <Box mt={2}>
                <Typography variant="subtitle2" color="textSecondary">
                  Skipped UPCs (already existed):
                </Typography>
                <Paper variant="outlined" style={{ maxHeight: 150, overflow: "auto", padding: 8 }}>
                  <pre style={{ margin: 0 }}>{importResult.skipped.join("\n")}</pre>
                </Paper>
              </Box>
            )}
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default AdminDrops2; 